module.exports = __webpack_public_path__ + "static/gallery-32780f1a1cebec5113b4180633f0b8a4.png";